import { useMutation, useQueryClient } from "@tanstack/react-query";
import { restoreLevel as apiRestore } from "../../api/apiLevels";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useRestoreLevel() {
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();

    const { mutate: restoreLevel, isPending: isRestore } = useMutation({
        mutationFn: (id) => apiRestore(id),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            queryClient.invalidateQueries({ queryKey: ["levels"] });
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { restoreLevel, isRestore };
}
